import { breakpoint } from '../utilities/screen_setup'
import { sliderDotsAnimation } from '../utilities/slider-dots-animation'

let video_slider = $('.video-slider-init')
let video_slider_opened = $('.video-slider-opened-init')
let video_slider_opened_wrapper = $('.video-slider-opened-init-wrapper')
let clicked_index = 0

if (video_slider.length && video_slider_opened.length) {

  let video_slider_slick = video_slider.slick({
    infinite: true,
    dots: false,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '10vw',
    useTransform: false,
    responsive: [
      {
        breakpoint: breakpoint('md'),
        settings: {
          dots: true,
          slidesToShow: 2,
          slidesToScroll: 1,
          centerPadding: '7vw',
        }
      },
      {
        breakpoint: breakpoint('sm'),
        settings: {
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: '5vw',
        }
      },
    ]
  })

  let video_slider_opened_slick = video_slider_opened.slick({
    infinite: true,
    dots: false,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    rows: 0,
    useTransform: false
  })

  if (breakpoint('full') > breakpoint('md')) {
    $('body').on('click', '.js-open-full-video', function (e) {
      e.preventDefault()

      let clicked_slide = $(this).closest('.slick-slide')

      hideVideoSlider(clicked_slide)
    })
  }

  $('body').on('click', '.close-opened-video', function (e) {
    e.preventDefault()
    $(this).removeClass('visible')
    video_slider_opened_slick.find('video').each(function () {
      $(this).get(0).pause()
      $(this).get(0).currentTime = 0
    })

    showVideoSlider()
  })

  function hideVideoSlider (clicked_slide) {
    clicked_index = parseInt(clicked_slide.attr('data-slick-index'))
    video_slider_opened_slick.slick('slickGoTo', clicked_index, true)

    video_slider.addClass('hidden')
    $('.close-opened-video').addClass('visible')
    video_slider_opened_wrapper.addClass('visible')

    playOrPauseOpenedVideo()
    recalculateOpenSlideAnimation()
  }

  function showVideoSlider () {
    recalculateOpenSlideAnimation()
    video_slider_opened_wrapper.removeClass('visible')
    video_slider.find('.animate-out-right').removeClass('animate-out-right')
    video_slider.find('.animate-out-left').removeClass('animate-out-left')
    video_slider.find('.no-visible').removeClass('no-visible')
    video_slider.removeClass('hidden')
    playOrPauseOpenedVideo()
  }

  function recalculateOpenSlideAnimation () {

    let allSlides = video_slider.find('.slick-slide')
    let center_index = parseInt(video_slider.find('.slick-center').attr('data-slick-index'))

    allSlides.each(function () {
      let thisIndex = parseInt($(this).attr('data-slick-index'))
      let addClass = clicked_index < thisIndex ? 'animate-out-right' : 'animate-out-left'
      if (clicked_index === thisIndex) {
        addClass = center_index < thisIndex ? 'animate-out-right' : 'animate-out-left'
      }
      $(this).addClass(addClass)
    })
  }

  function playOrPauseOpenedVideo () {
    video_slider_opened_wrapper.find('video').each(function () {
      //$(this).get(0).pause()
      //$(this).get(0).currentTime = 0
    })

    if (video_slider_opened_wrapper.hasClass('visible')) {
      let activeSlide = video_slider_opened.find('.slick-active')

      let video = activeSlide.find('video')
      startVideo(video)
    }
  }

  $('body').on('click', '.video-slider-navigation a[data-slick-move]', function (e) {
    e.preventDefault()
    video_slider_slick.slick($(this).attr('data-slick-move'))
    video_slider_opened_slick.slick($(this).attr('data-slick-move'))

    if (video_slider_opened_wrapper.hasClass('visible')) {
      recalculateOpenSlideAnimation()
    }

  })

  video_slider_opened_slick.on('afterChange', function (event, slick, currentSlide, nextSlide) {
    playOrPauseOpenedVideo()
  })

  video_slider_opened_slick.on('beforeChange', function (event, slick, currentSlide, nextSlide) {

    video_slider_opened_slick.find('video').each(function () {
      $(this).get(0).pause()
      $(this).get(0).currentTime = 0
    })

    let current_slide_html = $(this).parent().parent().find('.current-slide')
    current_slide_html.html(parseInt(nextSlide) + 1)

    let dots = $(this).parent().parent().find('.js-dots')
    sliderDotsAnimation(dots, currentSlide, nextSlide)

  })

  video_slider_slick.on('afterChange',
    function (event, slick, currentSlide, nextSlide) {
      video_slider_slick.find('video').each(function () {
        $(this).get(0).pause()
        $(this).get(0).currentTime = 0
      })

      let activeSlide = video_slider_slick.find('.slick-center')

      let video = activeSlide.find('video')
      startVideo(video)
    })

  $('body').on('mouseenter', '.video-slider-init .js-open-full-video', function (e) {
    //pauseAllSliderVideos()
    let video = $(this).find('video')
    startVideo(video)
  })

  $('body').on('mouseleave', '.video-slider-init .js-open-full-video', function (e) {
    let video = $(this).find('video')
    stopVideo(video)
  })

}

function startVideo(video){
  if (video.length) {
    video.show()
    video.get(0).play()
  }
}

function stopVideo(video) {
  if (video.length) {
    video.hide()
    video.get(0).pause()
  }
}
